/* Draft-theme integration. The Shopify discount remains the price authority. */
(() => {
  'use strict';
  if (window.ugglyGiftGuard) return;
  window.ugglyGiftGuard = true;
  const giftId = 51827711148278;
  const root = window.Shopify?.routes?.root || '/';
  const nativeFetch = window.fetch.bind(window);
  const query = new URLSearchParams(location.search);
  const market = query.get('country') || document.currentScript?.dataset.country || '';
  const context = new URLSearchParams();
  for (const key of ['country', 'currency']) if (query.has(key)) context.set(key, query.get(key));
  const endpoint = path => root + path + (context.size ? '?' + context : '');
  const noticeStyle = document.createElement('style');
  noticeStyle.textContent = 'body:has(cart-drawer.active) #uggly-gift-notice{display:none}';
  document.head?.append(noticeStyle);
  const state = text => {
    document.documentElement.dataset.ugglyGiftState = text;
    const messages = {
      'no-knife': 'FREE MASK UNLOCKED — add a knife to claim it. Ships separately.',
      ready: 'FREE MASK ADDED ($0) — ships separately.',
      'blocked-code': 'Your free mask could not be applied. It has not been added as a paid item.'
    };
    let notice = document.getElementById('uggly-gift-notice');
    if (!messages[text]) {if (notice) notice.remove(); return;}
    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'uggly-gift-notice';
      notice.setAttribute('role', 'status');
      notice.style.cssText = 'position:fixed;bottom:16px;left:16px;right:16px;max-width:480px;z-index:9998;background:#151515;color:#fff;padding:12px 16px;border-radius:8px;font:14px/1.4 Arial;box-shadow:0 2px 12px #0003';
      document.body.append(notice);
    }
    notice.textContent = messages[text];
  };
  if (query.get('uggly_gift') === '1') sessionStorage.setItem('ugglyGiftSignup', '1');
  const incomingCode = (query.get('discount') || '').split(',').find(c => /^UGGLYGIFT/i.test(c));
  if (incomingCode && incomingCode !== sessionStorage.getItem('ugglyGiftCode')) {
    sessionStorage.setItem('ugglyGiftCode', incomingCode);
    sessionStorage.removeItem('ugglyGiftBlocked');
  }
  let pending = Promise.resolve();
  const enrolled = () => sessionStorage.getItem('ugglyGiftSignup') === '1';
  const knife = item => item.variant_id !== giftId && !/sheath|holster|sharpener|knife block/i.test(item.product_title || '') && (/kniv|knife|cleaver/i.test(item.product_type || '') || /knife|cleaver/i.test(item.product_title || ''));
  const cart = async () => {
    const r = await nativeFetch(endpoint('cart.js'), {cache: 'no-store'});
    if (!r.ok) throw new Error('Cart could not be checked');
    return r.json();
  };
  const post = async (path, body) => {
    const r = await nativeFetch(endpoint(path), {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify(body)});
    if (!r.ok) throw new Error('Gift could not be updated');
    return r.json();
  };
  async function refreshDrawer(openAfterUpdate) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      document.documentElement.dataset.ugglyDrawerState = 'unavailable';
      return;
    }
    const result = await post('cart/update.js', {
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: location.pathname
    });
    if (!result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) throw new Error('Cart drawer could not be rendered');
    drawer.classList.remove('is-empty');
    drawer.renderContents(result, !openAfterUpdate);
    if (openAfterUpdate && typeof drawer.open === 'function') drawer.open();
    document.documentElement.dataset.ugglyDrawerState = 'updated';
  }
  async function reconcile() {
    if (!enrolled()) return false;
    let c = await cart();
    state('checking-' + c.item_count);
    const existingCode = (c.discount_codes || []).find(d => /^UGGLYGIFT/i.test(d.code || ''))?.code;
    if (existingCode) sessionStorage.setItem('ugglyGiftCode', existingCode);
    const isGift = i => i.variant_id === giftId && i.properties?._uggly_gift === 'recart';
    const gifts = c.items.filter(isGift);
    if (!c.items.some(knife)) {
      for (const g of gifts) await post('cart/change.js', {id: g.key, quantity: 0});
      state('no-knife');
      return gifts.length > 0;
    }
    let changed = false;
    if (!gifts.length) {
      if (sessionStorage.getItem('ugglyGiftBlocked') === '1') {state('blocked-code'); return false;}
      await post('cart/add.js', {items: [{id: giftId, quantity: 1, properties: {_uggly_gift: 'recart', Delivery: 'Gift mask ships separately from knives. Pre-order timing applies.'}}]});
      changed = true;
    } else {
      for (let n = 0; n < gifts.length; n++) {
        if (n || gifts[n].quantity !== 1 || gifts[n].properties?._uggly_gift !== 'recart') {
          const body = {id: gifts[n].key, quantity: n ? 0 : 1};
          if (!n) body.properties = {...gifts[n].properties, _uggly_gift: 'recart', Delivery: 'Gift mask ships separately from knives. Pre-order timing applies.'};
          await post('cart/change.js', body); changed = true;
        }
      }
    }
    c = await cart();
    const coupon = sessionStorage.getItem('ugglyGiftCode');
    if (coupon && c.items.some(i => isGift(i) && i.final_line_price > 0)) {
      const codes = Array.from(new Set([...(c.discount_codes || []).map(d => d.code).filter(Boolean), coupon]));
      await post('cart/update.js', {discount: codes.join(',')}); changed = true;
      c = await cart();
    }
    // Never leave an automatically claimed gift as a paid surprise item.
    for (const g of c.items.filter(isGift)) {
      if (g.final_line_price > 0) {
        sessionStorage.setItem('ugglyGiftBlocked', '1');
        await post('cart/change.js', {id: g.key, quantity: 0}); changed = true;
      }
    }
    const freeGift = c.items.some(i => isGift(i) && i.quantity === 1 && i.final_line_price === 0);
    state(sessionStorage.getItem('ugglyGiftBlocked') === '1' ? 'blocked-code' : freeGift ? 'ready' : 'not-added');
    return changed;
  }
  const run = () => (pending = pending.catch(() => {}).then(reconcile));
  // Only the completed Omnisend form unlocks the offer; individual step submits do not.
  window.addEventListener('omnisendForms', event => {
    const detail = event.detail || {};
    if (detail.form?.id !== '6ad46e83e171c7a9af2d16e6') return;
    const eventType = detail.type || detail.eventName;
    const completed = (eventType === 'stepSubmit' && Number(detail.step) === 2) || (eventType === 'submit' && !!detail.formValues?.phoneNumberField);
    if (!completed) return;
    try {localStorage.setItem('ugglyGiftCompleted', '1');} catch {}
    sessionStorage.setItem('ugglyGiftSignup', '1');
    sessionStorage.setItem('ugglyGiftCode', 'UGGLYGIFTOMNI26');
    sessionStorage.removeItem('ugglyGiftBlocked');
    run().catch(() => state('not-added'));
  });
  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const path = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
    if (enrolled() && /\/cart\/(add|change|update|clear)(\.js)?([?]|$)/.test(path) && response.ok) {
      setTimeout(() => run().then(changed => {if (changed) return refreshDrawer(/\/cart\/add/.test(path));}).catch(() => {document.documentElement.dataset.ugglyDrawerState = 'error';}), 150);
    }
    return response;
  };
  window.addEventListener('click', async event => {
    const control = event.target.closest('button[name="checkout"],input[name="checkout"],a[href="/checkout"]');
    if (!control || !enrolled()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    control.disabled = true;
    try {await run(); location.assign(root + 'checkout');}
    catch {control.disabled = false; alert('We could not verify your gift. Please refresh your cart before checkout.');}
  }, true);
  if (enrolled()) run().then(changed => {if (changed) return refreshDrawer(false);}).catch(() => {document.documentElement.dataset.ugglyDrawerState = 'error';});
  // Public display is controlled here so the enabled form cannot appear on a theme without gift support.
  const excludedPage = /\/(cart|checkout|checkouts)(\/|$)/.test(location.pathname) || location.pathname.includes('ultimate-squad-3-5-blade-limited-edition-pre-order');
  if (['US','CA'].includes(market) && !excludedPage) {
    setTimeout(() => {
      try {
        const lastShown = Number(localStorage.getItem('ugglyGiftLastShown') || '0');
        if (query.get('uggly_popup_preview') !== '1' && (localStorage.getItem('ugglyGiftCompleted') === '1' || Date.now() - lastShown < 7 * 86400000)) return;
        if (document.visibilityState !== 'visible' || document.querySelector('cart-drawer.active,[role="dialog"][aria-modal="true"]')) return;
        window.omnisend = window.omnisend || [];
        window.omnisend.push(['openForm', '6ad46e83e171c7a9af2d16e6']);
        localStorage.setItem('ugglyGiftLastShown', String(Date.now()));
      } catch { /* Do not interrupt shopping when browser storage is unavailable. */ }
    }, 8000);
  }

})();
